import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function deleteLeadIdentification(id) {
	const identificationRef = firebaseRef.ref(
		'/kavtek_leads/' +
			PROJECT_CODE.projectCode +
			'/' +
			id +
			'/identification'
	);
	await identificationRef.remove();
}
